export default IconBrandAzure => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-azure" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 7.5l-4 9.5h4l6 -15z" />
  <path d="M22 20l-7 -15l-3 7l4 5l-8 3z" />
</svg>`;